export default class ContractCancellationDataRequest {
  expirationObservation: string;

  justification: string;

  reasonsCancellation: string;

  churnResponsible: string;

  exemptFine: boolean;

  exemptFineApprover: string;

  exemptFineValue: any;

  exemptContractualTerm: boolean;

  billLastInvoice: boolean | null;

  constructor(obj: any = {}) {
    this.expirationObservation = obj.expirationObservation || '';
    this.justification = obj.justification || null;
    this.reasonsCancellation = obj.reasonsCancellation || null;
    this.churnResponsible = obj.churnResponsible || null;
    this.exemptFine = obj.exemptFine || null;
    this.exemptFineApprover = obj.exemptFineApprover || null;
    this.exemptFineValue = obj.exemptFineValue || 0;
    this.exemptContractualTerm = obj.exemptContractualTerm || false;
    this.billLastInvoice = obj.billLastInvoice ?? null;
  }

  public static of(obj: any = {}): ContractCancellationDataRequest {
    return new ContractCancellationDataRequest(obj || {});
  }

  public static ofList(obj: any[]): ContractCancellationDataRequest[] {
    return obj.map(this.of);
  }

  getExemptFineValueAsCurrency(): string {
    return this.exemptFineValue
      ? this.exemptFineValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      : 'R$ 0,00';
  }
}
